module.exports = __webpack_public_path__ + "static/media/galerija_2017 (37).4720afac.jpg";